module.exports = __webpack_public_path__ + "static/media/bank-icon-white.6e8bf036.svg";